// This file is auto-generated by 'pnpm rebuild:icons'
/* eslint-disable simple-import-sort/imports */

import type { Icon } from './icons/types.ts';

import AiBw from './icons/ai-bw.gts';
import ArrowLeft from './icons/arrow-left.gts';
import ArrowRight from './icons/arrow-right.gts';
import ArrowTopLeft from './icons/arrow-top-left.gts';
import ArrowUp from './icons/arrow-up.gts';
import BoxelIcon from './icons/boxel-icon.gts';
import BoxelIconWithText from './icons/boxel-icon-with-text.gts';
import Card from './icons/card.gts';
import CardbotLg from './icons/cardbot-lg.gts';
import CardDefinition from './icons/card-definition.gts';
import CardInstance from './icons/card-instance.gts';
import CaretDown from './icons/caret-down.gts';
import CheckMark from './icons/check-mark.gts';
import ChevronRight from './icons/chevron-right.gts';
import Copy from './icons/copy.gts';
import DiagonalArrowLeftUp from './icons/diagonal-arrow-left-up.gts';
import Download from './icons/download.gts';
import DropdownArrowDown from './icons/dropdown-arrow-down.gts';
import DropdownArrowFilled from './icons/dropdown-arrow-filled.gts';
import DropdownArrowUp from './icons/dropdown-arrow-up.gts';
import Exclamation from './icons/exclamation.gts';
import ExclamationCircle from './icons/exclamation-circle.gts';
import Eye from './icons/eye.gts';
import FailureBordered from './icons/failure-bordered.gts';
import Field from './icons/field.gts';
import File from './icons/file.gts';
import FileAlert from './icons/file-alert.gts';
import Folder from './icons/folder.gts';
import FourLines from './icons/four-lines.gts';
import Grid3x3 from './icons/grid-3x3.gts';
import Group from './icons/group.gts';
import HighlightIcon from './icons/highlight-icon.gts';
import IconCircle from './icons/icon-circle.gts';
import IconCircleSelected from './icons/icon-circle-selected.gts';
import IconCode from './icons/icon-code.gts';
import IconFunnel from './icons/icon-funnel.gts';
import IconGlobe from './icons/icon-globe.gts';
import IconGrid from './icons/icon-grid.gts';
import IconHexagon from './icons/icon-hexagon.gts';
import IconInherit from './icons/icon-inherit.gts';
import IconLink from './icons/icon-link.gts';
import IconList from './icons/icon-list.gts';
import IconMinusCircle from './icons/icon-minus-circle.gts';
import IconPencil from './icons/icon-pencil.gts';
import IconPencilCrossedOut from './icons/icon-pencil-crossed-out.gts';
import IconPencilNotCrossedOut from './icons/icon-pencil-not-crossed-out.gts';
import IconPlus from './icons/icon-plus.gts';
import IconPlusCircle from './icons/icon-plus-circle.gts';
import IconPlusThin from './icons/icon-plus-thin.gts';
import IconSearch from './icons/icon-search.gts';
import IconSearchThick from './icons/icon-search-thick.gts';
import IconTrash from './icons/icon-trash.gts';
import IconTurnDownRight from './icons/icon-turn-down-right.gts';
import IconX from './icons/icon-x.gts';
import ImagePlaceholder from './icons/image-placeholder.gts';
import LoadingIndicator from './icons/loading-indicator.gts';
import Lock from './icons/lock.gts';
import Profile from './icons/profile.gts';
import PublishSiteIcon from './icons/publish-site-icon.gts';
import Rows4 from './icons/rows-4.gts';
import Send from './icons/send.gts';
import Sparkle from './icons/sparkle.gts';
import Star from './icons/star.gts';
import StarFilled from './icons/star-filled.gts';
import StarHalfFill from './icons/star-half-fill.gts';
import SuccessBordered from './icons/success-bordered.gts';
import ThreeDotsHorizontal from './icons/three-dots-horizontal.gts';
import TriangleLeft from './icons/triangle-left.gts';
import TriangleRight from './icons/triangle-right.gts';
import Upload from './icons/upload.gts';
import Warning from './icons/warning.gts';

export const ALL_ICON_COMPONENTS = [
  AiBw,
  ArrowLeft,
  ArrowRight,
  ArrowTopLeft,
  ArrowUp,
  BoxelIcon,
  BoxelIconWithText,
  Card,
  CardbotLg,
  CardDefinition,
  CardInstance,
  CaretDown,
  CheckMark,
  ChevronRight,
  Copy,
  DiagonalArrowLeftUp,
  Download,
  DropdownArrowDown,
  DropdownArrowFilled,
  DropdownArrowUp,
  Exclamation,
  ExclamationCircle,
  Eye,
  FailureBordered,
  Field,
  File,
  FileAlert,
  Folder,
  FourLines,
  Grid3x3,
  Group,
  HighlightIcon,
  IconCircle,
  IconCircleSelected,
  IconCode,
  IconFunnel,
  IconGlobe,
  IconGrid,
  IconHexagon,
  IconInherit,
  IconLink,
  IconList,
  IconMinusCircle,
  IconPencil,
  IconPencilCrossedOut,
  IconPencilNotCrossedOut,
  IconPlus,
  IconPlusCircle,
  IconPlusThin,
  IconSearch,
  IconSearchThick,
  IconTrash,
  IconTurnDownRight,
  IconX,
  ImagePlaceholder,
  LoadingIndicator,
  Lock,
  Profile,
  PublishSiteIcon,
  Rows4,
  Send,
  Sparkle,
  Star,
  StarFilled,
  StarHalfFill,
  SuccessBordered,
  ThreeDotsHorizontal,
  TriangleLeft,
  TriangleRight,
  Upload,
  Warning,
];
export {
  type Icon,
  AiBw,
  ArrowLeft,
  ArrowRight,
  ArrowTopLeft,
  ArrowUp,
  BoxelIcon,
  BoxelIconWithText,
  Card,
  CardbotLg,
  CardDefinition,
  CardInstance,
  CaretDown,
  CheckMark,
  ChevronRight,
  Copy,
  DiagonalArrowLeftUp,
  Download,
  DropdownArrowDown,
  DropdownArrowFilled,
  DropdownArrowUp,
  Exclamation,
  ExclamationCircle,
  Eye,
  FailureBordered,
  Field,
  File,
  FileAlert,
  Folder,
  FourLines,
  Grid3x3,
  Group,
  HighlightIcon,
  IconCircle,
  IconCircleSelected,
  IconCode,
  IconFunnel,
  IconGlobe,
  IconGrid,
  IconHexagon,
  IconInherit,
  IconLink,
  IconList,
  IconMinusCircle,
  IconPencil,
  IconPencilCrossedOut,
  IconPencilNotCrossedOut,
  IconPlus,
  IconPlusCircle,
  IconPlusThin,
  IconSearch,
  IconSearchThick,
  IconTrash,
  IconTurnDownRight,
  IconX,
  ImagePlaceholder,
  LoadingIndicator,
  Lock,
  Profile,
  PublishSiteIcon,
  Rows4,
  Send,
  Sparkle,
  Star,
  StarFilled,
  StarHalfFill,
  SuccessBordered,
  ThreeDotsHorizontal,
  TriangleLeft,
  TriangleRight,
  Upload,
  Warning,
};
